import {NgModule} from '@angular/core';

import {MzToastService} from './services';

@NgModule({
  providers: [MzToastService],
})
export class MzToastModule {
}
